<template>
  <div>
    <Box theme="box-secondary">
      <div slot="content">
        <b-table bordered outlined responsive :busy="loading" :fields="fields" :items="items" show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>

          <template #empty="scope">
            <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
          </template>

          <template v-slot:cell(created_at)="data">
            <span>{{data.item.created_at | format_date_time}}</span>
          </template>
          <template v-slot:cell(product)="data">
            {{data.item.product.name}}
          </template>
          <template v-slot:cell(debt)="data">
            <span>{{data.item.debt | format_currency}}</span>
          </template>
          <template v-slot:cell(quantity)="data">
            <span>{{data.item.quantity}}</span>
          </template>

          <template v-slot:cell(actions)="data">
            <input type="checkbox" id="checkbox" v-model="data.item.is_checked" @change="check(data.item)"
                   :disabled="disableSelection"/>
          </template>
        </b-table>
      </div>

      <div slot="footer" class="d-flex align-items-center justify-content-between">
        <div class="page-size-container">
          <span>Hiển thị</span>
          <b-form-select
            id="pageSize"
            v-model="pageSize"
            :options="pageSizes"
            required
          ></b-form-select>
          <span>  dòng</span>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="pageSize"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </Box>
  </div>
</template>

<script>
import Box from '../../components/Box'
import OrderDetailApi from '../../api/orderDetailApi'
import Utils from '../../common/utils'
import DatePicker from 'vue2-datepicker'
import {mapActions, mapGetters} from 'vuex'
import ProductTable from '../../components/ProductTable'
import AnnualPayment from './AnnualPayment'

export default {
  name: 'OrderDetailPaymentList',
  components: {
    AnnualPayment,
    Box,
    DatePicker,
    ProductTable
  },
  props: {
    updatingOrderId: {
      type: Number,
      required: true
    },
    updateSelectedOrderDetail: {
      type: Function,
      required: true
    },
    disableSelection: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: 'NEW_BUY'
    }
  },
  data () {
    return {
      orderId: null,
      company: null,
      fields: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      checked: false,
      selectedOrderDetail: new Map(),
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      items: [
      ],
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'initOrderDetailId'
    ])
  },
  mounted () {
    this.reloadOrderDetailList()
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    },
    disableSelection: {
      handler: function () {
        this.items.forEach(item => {
          item.is_checked = this.disableSelection
          return item
        })
      }
    }
  },
  methods: {
    ...mapActions([
      'updateInitOrderDetailId'
    ]),
    reloadOrderDetailList () {
      this.company = Utils.getCompanyByUserInfo(this.userInfo)
      if (this.updatingOrderId) {
        this.orderId = this.updatingOrderId
        this.filter()
      }
      this.fields = [
        {
          key: 'product',
          label: 'Sản phẩm',
          show: true
        }, {
          key: 'quantity',
          label: 'Số lượng',
          show: true
        }, {
          key: 'debt',
          label: 'Số tiền nợ',
          show: true
        }, {
          key: 'actions',
          label: 'Chọn',
          thStyle: 'width: 100px',
          class: 'actions-cell',
          show: true
        }
      ]
    },
    buildFilterData () {
      return {order_id: this.orderId, type: this.type}
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      OrderDetailApi.filter(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records.map(item => {
          return {is_checked: this.selectedOrderDetail.has(item.id), ...item}
        })
        this.totalRow = res.data.data.total
        if (this.initOrderDetailId) {
          this.items.forEach(item => {
            if (item.id === this.initOrderDetailId.orderDetailId) {
              item.is_checked = true
              this.check(item)
              this.updateInitOrderDetailId({selectedOrderDetail: null})
            }
          })
        }
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    check (orderDetail) {
      if (this.selectedOrderDetail.has(orderDetail.id)) {
        this.selectedOrderDetail.delete(orderDetail.id)
      } else {
        this.selectedOrderDetail.set(orderDetail.id, orderDetail)
      }

      this.updateSelectedOrderDetail(this.selectedOrderDetail)
    },
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderDetailPaymentList.vue